import { getApiBaseUrl } from './config';
import { retryRequest } from './network/retryRequest';

async function sendApiRequest(path, { token, method = 'GET', body } = {}) {
  const base = getApiBaseUrl();
  if (!base) {
    throw new Error('API URL is not configured');
  }

  const headers = { Accept: 'application/json' };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  if (body !== undefined) {
    headers['Content-Type'] = 'application/json';
  }

  let response;
  try {
    response = await fetch(`${base}${path}`, {
      method,
      headers,
      body: body !== undefined ? JSON.stringify(body) : undefined,
    });
  } catch (error) {
    const networkError = error instanceof Error ? error : new Error('NetworkError when attempting to fetch resource.');
    networkError.name = 'TypeError';
    throw networkError;
  }

  const text = await response.text();
  let data = null;
  if (text) {
    try {
      data = JSON.parse(text);
    } catch {
      data = { error: text };
    }
  }

  if (!response.ok) {
    const error = new Error((data && data.error) || `API ${response.status}`);
    error.status = response.status;
    error.body = data;
    throw error;
  }

  return data;
}

export async function apiRequest(path, options = {}) {
  return retryRequest(() => sendApiRequest(path, options));
}
